import React from 'react';
import { Upload, FileText } from 'lucide-react';
import { useAppContext } from '../../context/AppContext';

const DocumentsTab = () => {
  const { currentUser, uploadedFiles, setUploadedFiles } = useAppContext();

  const handleFileUpload = (event) => {
    const files = Array.from(event.target.files);
    const newFiles = files.map(file => ({
      id: Date.now() + Math.random(),
      name: file.name,
      size: file.size,
      type: file.type,
      uploadedBy: currentUser.name,
      uploadedAt: new Date().toISOString()
    }));
    setUploadedFiles([...uploadedFiles, ...newFiles]);
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-gray-900">Session Documents</h3>
        <label className="flex items-center space-x-2 bg-[#01006A] text-white px-4 py-2 rounded-lg hover:bg-[#010059] cursor-pointer">
          <Upload className="w-5 h-5" />
          <span>Upload Files</span>
          <input
            type="file"
            multiple
            onChange={handleFileUpload}
            className="hidden"
            accept=".pdf,.txt,.doc,.docx"
          />
        </label>
      </div>

      <div className="space-y-3">
        {uploadedFiles.map(file => (
          <div key={file.id} className="flex items-center justify-between bg-gray-50 p-4 rounded-lg border border-gray-200">
            <div className="flex items-center space-x-3">
              <FileText className="w-8 h-8 text-[#01006A]" />
              <div>
                <div className="font-medium text-gray-900">{file.name}</div>
                <div className="text-xs text-gray-500">
                  Uploaded by {file.uploadedBy} • {new Date(file.uploadedAt).toLocaleDateString()}
                </div>
              </div>
            </div>
            <div className="text-sm text-gray-600">
              {(file.size / 1024).toFixed(1)} KB
            </div>
          </div>
        ))}

        {uploadedFiles.length === 0 && (
          <div className="text-center py-12 text-gray-500">
            <FileText className="w-12 h-12 mx-auto mb-4 text-gray-400" />
            <p>No documents uploaded yet.</p>
            <p className="text-sm mt-2">Upload PDFs, Word docs, or text files for analysis.</p>
          </div>
        )}
      </div>

      {uploadedFiles.length > 0 && (
        <div className="mt-6 bg-[#e6e6f5] p-4 rounded-lg border border-[#9696d4]">
          <h4 className="font-semibold text-[#000030] mb-2">ML Analysis Ready</h4>
          <p className="text-sm text-[#010059] mb-3">
            Documents uploaded. AI can extract topics, keywords, and summarize content.
          </p>
          <button className="bg-[#01006A] text-white px-4 py-2 rounded-lg text-sm hover:bg-[#010059]">
            Run Analysis
          </button>
        </div>
      )}
    </div>
  );
};

export default DocumentsTab;